import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as summit from '../summit'

export const RESOURCE = {
  payload: {
    alias: 'org',
    appAlias: summit.RESOURCE.payload.alias,
    description:
      'Ensure your organization is aligned in the pursuit of your mission',
    display: {
      isMain: false,
      position: 0,
    },
    name: 'Organization',
    page: { id: prebuilt.Page.Id.SummitOrganization },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
